"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ShareDetail["default"];
  }
});
var _ShareDetail = _interopRequireDefault(require("./ShareDetail"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }